module.exports = __webpack_public_path__ + "static/media/monsterjerky.141a1b74.webp";